"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ScrumTaskRow;
const react_1 = __importStar(require("react"));
const InlineEstimateInput_1 = __importDefault(require("./InlineEstimateInput"));
const InlineStatusDropdown_1 = __importDefault(require("./InlineStatusDropdown"));
const InlineWeekHoursEditor_1 = __importDefault(require("./InlineWeekHoursEditor"));
const toYmd = (d) => (d ? String(d).slice(0, 10) : "");
/**
 * Wiersz zadania: nazwa | termin | status | właściciel | szac. czas | czas rzeczywisty.
 * Inline-edytowalne: status, szac. czas, godziny PO-PT. Termin i właściciel — tylko podgląd.
 * Mutuje obiekt task (współdzielony z drzewem) + lokalny stan, by zmiana była widoczna od razu.
 * Po zaznaczeniu wiersza (isActive) nazwa przestaje być ucinana, a pod nią pojawiają się uwagi.
 */
function ScrumTaskRow({ task, isActive = false }) {
    const [, forceRender] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        forceRender((n) => n + 1);
    }, [task.id]);
    function applyChange(patch) {
        Object.assign(task, patch);
        forceRender((n) => n + 1);
    }
    return (react_1.default.createElement("div", { className: "scrum-task-row" },
        react_1.default.createElement("div", { className: "d-flex align-items-center gap-3" },
            react_1.default.createElement("span", { className: `scrum-task-name flex-grow-1 ${isActive ? "text-break" : "text-truncate"}` }, task.name),
            react_1.default.createElement("div", { className: "scrum-task-field text-secondary small" }, toYmd(task.deadline)),
            react_1.default.createElement("div", { className: "scrum-task-field" },
                react_1.default.createElement(InlineStatusDropdown_1.default, { task: task, onSaved: (status) => applyChange({ status }) })),
            react_1.default.createElement("div", { className: "scrum-task-field text-secondary small text-truncate scrum-task-owner" }, task._owner ? `${task._owner.name} ${task._owner.surname}` : "—"),
            react_1.default.createElement("div", { className: "scrum-task-field" },
                react_1.default.createElement("span", { className: "text-muted small me-1" }, "szac.:"),
                react_1.default.createElement(InlineEstimateInput_1.default, { task: task, onSaved: ({ estimatedHours }) => applyChange({ estimatedHours }) })),
            react_1.default.createElement("div", { className: "scrum-task-field" },
                react_1.default.createElement("span", { className: "text-muted small me-1" }, "rzecz.:"),
                react_1.default.createElement(InlineWeekHoursEditor_1.default, { task: task, onSaved: (hours) => applyChange({
                        hoursMon: hours.hoursMon,
                        hoursTue: hours.hoursTue,
                        hoursWed: hours.hoursWed,
                        hoursThu: hours.hoursThu,
                        hoursFri: hours.hoursFri,
                    }) }))),
        isActive && task.description && (react_1.default.createElement("div", { className: "scrum-task-description text-secondary small text-break" }, task.description))));
}
